import React from 'react';
import { MarketList } from './MarketList';
import { PanelMarketLaunch, PanelSection } from './PanelMarketLaunch';

type Props = {
  survey: any;
  // Panel markets only (the page filters them).
  markets: any[];
  selectedId: string;
  onSelect: (id: string) => void;
  // Which tab this pane is: Samples or Schedule.
  section: PanelSection;
  // Schedule only: the market's panel launch settings form, shown above the
  // email templates and schedule.
  renderLaunchSettings?: (market: any) => React.ReactNode;
};

export const PanelLaunchPane: React.FC<Props> = ({ survey, markets, selectedId, onSelect, section, renderLaunchSettings }) => {
  const launch = (m: any) => (section === 'schedule' && renderLaunchSettings ? renderLaunchSettings(m) : undefined);
  // A child page launches itself: no list.
  if (survey?.parentid) return <PanelMarketLaunch market={survey} section={section} launchSettings={launch(survey)} key={survey.id} />;

  const selected = markets.find((m) => String(m.id) === String(selectedId));
  return (
    <div className="row">
      <div className="col-md-3">
        <div className="dx-card dx-market-list">
          <MarketList markets={markets} selectedId={selectedId} onSelect={onSelect} />
        </div>
      </div>
      <div className="col-md-9">
        {selected
          ? <PanelMarketLaunch market={selected} section={section} launchSettings={launch(selected)} key={selected.id} />
          : <div className="dx-card text-muted">No panel market selected.</div>}
      </div>
    </div>
  );
};
